const OpportunityTypes = require('helpers/opportunity-types');

const InstrumentType = require('helpers/instrument-type');

module.exports.isOpportunityContainedUnits = (opportunityType) => [
    OpportunityTypes.TREASURY_BILL,
    OpportunityTypes.CORPORATE_BOND,
    OpportunityTypes.SDL,
    OpportunityTypes.SECURITISED_DEBT_INSTRUMENT,
    OpportunityTypes.G_SEC,
    OpportunityTypes.SOVEREIGN_GOLD_BONDS,
    OpportunityTypes.UNLISTED_SECURITISED_DEBT_INSTRUMENT
].includes(opportunityType);

module.exports.isOpportunityContainedUnitsByInstrument = (instrument) => [
    InstrumentType.PRIVATE_NCD,
    InstrumentType.PUBLIC_NCD,
    InstrumentType.TREASURY_BILLS,
    InstrumentType.SOVEREIGN_GOLD_BONDS,
    InstrumentType.SECURITISED_DEBT_INSTRUMENT
].includes(instrument);

module.exports.getUnitsOpportunities = () => [
    OpportunityTypes.TREASURY_BILL,
    OpportunityTypes.CORPORATE_BOND,
    OpportunityTypes.SDL,
    OpportunityTypes.SECURITISED_DEBT_INSTRUMENT,
    OpportunityTypes.UNLISTED_SECURITISED_DEBT_INSTRUMENT,
    OpportunityTypes.G_SEC,
    OpportunityTypes.SOVEREIGN_GOLD_BONDS
];

// Todo -  check impact of USDI
module.exports.isSDI = (opportunityType) =>
    opportunityType === OpportunityTypes.SECURITISED_DEBT_INSTRUMENT
    || opportunityType === OpportunityTypes.UNLISTED_SECURITISED_DEBT_INSTRUMENT;

module.exports.isUnlistedSDI = (opportunityType) =>
    opportunityType === OpportunityTypes.UNLISTED_SECURITISED_DEBT_INSTRUMENT;

module.exports.isTBILL = (opportunityType) => {
    return opportunityType === OpportunityTypes.TREASURY_BILL;
}

module.exports.getNonUnitsOpportunities = () => [];
